import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class EnsureHttpsInterceptor implements HttpInterceptor {
  constructor(private spinner: NgxSpinnerService,) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // clone request and replace 'http://' with 'https://' at the same time
    const secureReq = req.clone({
      url: req.url.replace('https://', 'https://')
    });
    // this.spinner.show();
    // return next.handle(secureReq).pipe(
    //     finalize(() => this.spinner.hide())
    // );
    // send the cloned, "secure" request to the next handler.
    return next.handle(secureReq);
  }
}